var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "841.891px",
    height: "595.281px",
    viewBox: "0 0 841.891 595.281",
    enableBackground: "new 0 0 841.891 595.281",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00BD39",
    points: "516.19,0 516.19,291.687 325.7,0 123.304,0 123.304,595.281 325.7,595.281 325.7,297.64  516.19,595.281 718.586,595.281 718.586,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverLogo);
export default __webpack_public_path__ + "static/media/naver_logo.ee6ae48e9cfbe43ae55cee6752ad16bf.svg";
export { ForwardRef as ReactComponent };